import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, Events } from 'ionic-angular';
import { HttpClient } from '../../../../services/HttpClient';
import { CustomToast } from '../../../../util/CustomToast';

import { ImageSelector } from '../../../../util/imageSelector/imageSelector';

@Component({
  selector: 'page-add-slide',
  templateUrl: 'addSlide.html',
  providers : [HttpClient, CustomToast]
})
export class AddSlidePage {

  modalCtrl : ModalController;
	
  httpClient : HttpClient;
  baseUrl;

  image = {
    id : -1,
    filename : 'addimage.png'
  };

  slide = {
    position : 1,
    image : '',
    title_es : '',
    title_en : '',
    text_es : '',
    text_en : '',
    button_es : '',
    button_en : '',
    url : ''
  };

  positions = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20];

  customToast : CustomToast;
  events : Events;

	constructor(public navCtrl: NavController, public navParams: NavParams, httpClient : HttpClient,customToast : CustomToast,modalCtrl : ModalController, events : Events) {
		this.modalCtrl = modalCtrl;
    this.httpClient = httpClient;
    this.baseUrl = this.httpClient.getBaseUrl();
    
    this.customToast = customToast;
    this.events = events;

	}

  onClickImage(){
    let modal = this.modalCtrl.create(ImageSelector);
    modal.present();
    modal.onDidDismiss(image => {
      if(image){
        this.image = image;
        this.slide.image = image.filename;
      }
    });
  }

  httpPostSlide(){
    this.httpClient.post('/slides',this.slide,(error,data)=>{
      if(!error){
        this.customToast.showMessage('Slide creado correctamente',2000);
        this.navCtrl.pop();
        this.events.publish('addSlide:done');
      }
    });
  }

  onClickSave(){
    this.httpPostSlide();
  }



}



// WEBPACK FOOTER //
// ./src/pages/dashboard/slides/addSlide/addSlide.ts